import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { UIRouterModule } from '@uirouter/angular';
import { ProjectDisplayModule } from '../project-display/project-display.module';
import { ProjectSummaryModule } from '../project-summary/project-summary.module';
import { LegacyNotificationActionsService } from './data-access/legacy-notification-actions.service';
import { NotificationCentrePageComponent } from './feature/notification-centre-page/notification-centre-page.component';
import { ProjectWatchPageComponent } from './feature/project-watch-page/project-watch-page.component';
import { NotificationWatchListComponent } from './ui/notification-watch-list/notification-watch-list.component';

@NgModule({
    declarations: [
        NotificationCentrePageComponent,
        ProjectWatchPageComponent,
        NotificationWatchListComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatTableModule,
        MatButtonModule,
        MatCheckboxModule,
        MatIconModule,
        MatSidenavModule,
        UIRouterModule,
        ProjectDisplayModule,
        ProjectSummaryModule
    ],
    providers: [LegacyNotificationActionsService]
})
export class NotificationsModule { }
